import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalStorageToken } from '../util/constant';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private baseUrl = environment.apiBaseUrl;
  private tokenKey = LocalStorageToken;
  private timeoutId: any;

  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<{ token: string; expiresIn: number }> {
    return this.http
      .post<{
        token: string;
        expiresIn: number;
      }>(`${this.baseUrl}/api/account/login`, { username, password })
      .pipe(tap((res) => this.setToken(res.token, res.expiresIn)));
  }

  setToken(token: string, expiresIn: number) {
    localStorage.setItem(this.tokenKey, token);

    // Clear previous timer if any
    if (this.timeoutId) clearTimeout(this.timeoutId);

    // Auto-clear token on expiry
    this.timeoutId = setTimeout(() => this.clearToken(), expiresIn * 1000);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  clearToken() {
    localStorage.removeItem(this.tokenKey);
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  logout() {
    this.clearToken();
  }
}
